import _ from 'underscore';
import Promise from 'bluebird';

import { isTimeRangeValid, segmentationType } from '@bingads-webui-campaign/segmentation-utilities';
import { PILL_CONTROL } from './consts';

const supportedTimeSegments = [
  segmentationType.Day,
  segmentationType.Week,
  segmentationType.Month,
  segmentationType.Quarter,
  segmentationType.Year,
];

export class GeneralInsightsSegmentationDecorator {
  constructor(alwaysAddSegment = false) {
    this.alwaysAddSegment = alwaysAddSegment;
  }

  addSegmentToQuery(queryParams = {}) {
    const query = _.result(queryParams, 'query', {});
    const pillControlType = query.PillControlType;
    const segType = query.SegmentationTypes;

    if (!this.alwaysAddSegment &&
      (pillControlType !== PILL_CONTROL.overtime || _.contains(supportedTimeSegments, segType))) {
      return queryParams;
    }

    const newSegment = this.getDefaultTimeSegment(query);

    const newQuery = _.defaults({
      SegmentationTypes: _.compact([segType, newSegment]),
    }, queryParams.query);

    return _.defaults(
      {
        query: newQuery,
      },
      queryParams
    );
  }

  getDefaultTimeSegment(queryDateRange) {
    const dateRange =
    {
      start: new Date(queryDateRange.startDate),
      end: new Date(queryDateRange.endDate),
    };

    // Find smallest valid date segmentation
    const dateSegmentations = [
      segmentationType.Day,
      segmentationType.Week,
      segmentationType.Month,
      segmentationType.Quarter,
      segmentationType.Year,
    ];

    return _.find(
      dateSegmentations,
      dateSegmentation => isTimeRangeValid(dateSegmentation, dateRange)
    );
  }

  /* istanbul ignore next */
  run(queryParams) {
    return Promise.resolve(this.addSegmentToQuery(queryParams));
  }
}
